module.exports = __webpack_public_path__ + "media/images/product-banners/htt-253a4762a09b9bf007914663ce54cf33.svg";